<template>
  <div class="not-f3">
    <v-layout  align-center="">

      <div>{{notTitle?notTitle:"Rows per page:"}}</div>
      <div style="width:'2px';"  class="px-5">
        <v-select
          @change="onPager()"
          :style="width"
          :items="items" 
          v-model="pages"/> 

      </div>
      <div class="pr-2">
        {{paginate.start}} - {{paginate.last}} 0f {{paginate.total}}
      </div>
      <v-btn :disabled="!paginate.prev" @click="previous()" icon=""><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn :disabled="!paginate.next" @click="next()" icon="" class="mr-2"><v-icon>mdi-chevron-right</v-icon></v-btn>
    </v-layout>
  </div>
</template>

<script>
import { timeout } from 'q'
export default {
  props:["not","notShow","notTitle","notData"],
  data: () => ({
     menu:false,
     pages:10,
     currentPage:1,
     items:[5,10,15,20,"All"],
     width:"width: 50px; font-size: 10pt;" ,
     pager:[],
     chenged : false,
  }),
  mounted(){
    this.onPager()
  },
  computed: { 
    us(){
      return this.not.us
    },
    ud(){
      return this.not.ud
    },
    paginate(){ 
      let pg = this.not.pagination(this.notData,this.currentPage,this.pages)
        //reset page
        if(pg.page>pg.pages){ 
          this.currentPage = 1 
          this.next() 
        }   
      return pg
    },
  },
  methods: {
    onPager(){
      this.$emit("input",this.paginate)
    },
    next(){
      let pg = this.paginate
      if (pg.pages>pg.page) {
        this.currentPage = this.currentPage+1 
      }else{
        this.currentPage = 1 
      }
      this.onPager()
    },
    previous(){
      let pg = this.paginate
      if (pg.page>1) {
        this.currentPage = this.currentPage-1 
      }else{
        this.currentPage = pg.pages 
      }
      this.onPager()
    },
    clicked(){}
  },
  watch:{
    notData(v){
      
       
    },paginate(v){
      // if (this.chenged) {
      //   this.chenged = false
      //   setTimeout(() => {
      //     this.$emit("input",v)
      //     console.log(v); 
      //   }, 1000); 
      // }
    },
    pager(v){
      // console.log(v);
      // //this.$emit("input",v)
    }
  }
};
</script>
